// Debug Analytics Provider
//
// This provider logs all analytics events for development and debugging purposes.
// It helps developers understand what events are being tracked and with what data.

import { logger } from '../../utils/core/logger';
import type { AnalyticsEvent } from '../types';
import { BaseAnalyticsProvider } from './base';

export class DebugProvider extends BaseAnalyticsProvider {
    public readonly name = 'debug';

    public eventFilter(_event: AnalyticsEvent): boolean {
        // Accept all events for debugging
        return true;
    }

    protected async sendEventImpl(event: AnalyticsEvent): Promise<void> {
        // Log detailed event information for debugging
        logger.debug('🔍 DEBUG ANALYTICS EVENT:', {
            type: event.type,
            category: event.category,
            properties: event.properties,
            context: {
                ...event.context,
                personId: event.context.personId, // Highlight personId in debug output
            },
            timestamp: new Date(event.timestamp).toISOString(),
        });
    }

    protected async sendEvent(event: AnalyticsEvent): Promise<void> {
        await this.sendEventImpl(event);
    }
}
